import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';

// Action Creators
export const updateQuestionRequest = () => ({
  type: UPDATE_QUESTION,
});

export const updateQuestionSuccess = (users) => ({
  type: UPDATE_QUESTION_SUCCESS,
  payload: users,
});

export const updateQuestionFailure = (error) => ({
  type: UPDATE_QUESTION_FAILURE,
  payload: error,
});

// Thunk Function
export const updateQuestion = (external, body, id) => {
  return async (dispatch) => {
    dispatch(updateQuestionRequest());
    try {
      const response = await putMethodWithToken(
        url.updateQuestion + id + '/',
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateQuestionSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateQuestionFailure('error?.message'));
      }
    } catch (error) {
      dispatch(updateQuestionFailure(error?.message));
    }
  };
};
